<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Stawki serwisowe</h4>
              <button v-if="hasPermission('canAddEditRate')" @click="addServiceCat" class="btn btn-primary btn-sm"><i
                  class="bi bi-plus-circle me-2"></i>Dodaj
                stawkę
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">

          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>

          <div class="custom-table">
            <div class="table-responsive">
              <table id="servicecat-table" class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa kategorii</th>
                  <th>Opis</th>
                  <th>Stawka - koszt</th>
                  <th>Stawka - klient</th>
                  <th>Stworzony</th>
                  <th>Zaktualizowany</th>
                  <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(servicecat, scatId) in service_rate_category" :key="scatId">
                  <td>{{ servicecat.id }}</td>
                  <td>
                    <input v-if="editingId === servicecat.id" v-model="servicecat.name" class="form-control"/>
                    <span v-else>{{ servicecat.name }}</span>
                  </td>
                  <td>
                    <input v-if="editingId === servicecat.id" v-model="servicecat.description" class="form-control"/>
                    <span v-else>{{ servicecat.description }}</span>
                  </td>
                  <td>
                    <input v-if="editingId === servicecat.id" v-model="servicecat.price_company" class="form-control"/>
                    <span v-else>{{ formatMoney(servicecat.price_company) }}</span>
                  </td>
                  <td>
                    <input v-if="editingId === servicecat.id" v-model="servicecat.price_client" class="form-control"/>
                    <span v-else>{{ formatMoney(servicecat.price_client) }}</span>
                  </td>
                  <td>{{ formatDate(servicecat.created_at) }}</td>
                  <td>{{ formatDate(servicecat.updated_at) }}</td>
                  <td>
                    <button v-if="editingId === servicecat.id" @click="updateServiceCat(servicecat)"
                            class="btn btn-sm btn-success me-2">Zapisz
                    </button>
                    <button v-else v-if="hasPermission('canAddEditRate')" @click="editServiceCat(servicecat.id)"
                            class="btn btn-sm btn-outline-info me-2"><i
                        class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                    <button v-if="hasPermission('canDelRate')" @click="deleteServiceCat(servicecat.id)"
                            class="btn btn-sm btn-danger"><i
                        class="bi bi-trash me-2"></i>Usuń
                    </button>
                  </td>
                </tr>
                <tr v-if="addingNew">
                  <td>Nowy</td>
                  <td><input v-model="newServiceCat.name" class="form-control"/></td>
                  <td><input v-model="newServiceCat.description" class="form-control"/></td>
                  <td><input v-model="newServiceCat.price_company" class="form-control"/></td>
                  <td><input v-model="newServiceCat.price_client" class="form-control"/></td>
                  <td>-</td>
                  <td>-</td>
                  <td>
                    <button @click="saveNewServiceCat" class="btn btn-sm btn-success me-1"><i
                        class="bi bi-save me-2"></i>Zapisz
                    </button>
                    <button @click="cancelNewServiceCat" class="btn btn-sm btn-danger"><i
                        class="bi bi-x-circle me-2"></i>Anuluj
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>


<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, hasPermission},
  props: {
    users: Object,
    service_rate_category: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newServiceCat: this.getEmptyForm()
    };
  },

  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getEmptyForm() {
      return {
        id: null,
        name: '',
        description: '',
        price_company: '',
        price_client: ''
      };
    },

    addServiceCat() {
      this.addingNew = true;
      this.newServiceCat = this.getEmptyForm();
    },

    cancelNewServiceCat() {
      this.addingNew = false;
      this.newServiceCat = this.getEmptyForm();
    },

    editServiceCat(id) {
      this.editingId = id;
    },

    updateServiceCat(servicecat) {
      this.$inertia.put(route('service.servicecat.update', servicecat.id), servicecat, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },

    saveNewServiceCat() {
      this.$inertia.post(route('service.servicecat.store'), this.newServiceCat, {
        onSuccess: () => {
          this.addingNew = false;
          this.newServiceCat = this.getEmptyForm();
        }
      });
    },

    formatMoney(value) {
      return new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },

    deleteServiceCat(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie kategorii',
        html: 'Czy na pewno chcesz usunąć wybraną kategorię?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('service.servicecat.destroy', id));
        }
      })
    }
  }
}
</script>


<style>

</style>